import {
  formAddressToProfileShape,
  isSameMailingAddress,
} from '../profile-address-mismatch/addressCompare';

/**
 * Whether the address the user entered is the profile's mailing address and
 * VA Profile has flagged that address as undeliverable (mail sent to it was
 * returned). When true there's nothing for USPS validation to add: the
 * address is already on file and validated, the problem is that mail bounced.
 *
 * @param {Object} formAddress - addressUI-shaped address from form data
 * @param {Object} [profileMailingAddress] - VA Profile mailing address
 *   (state.user.profile.vapContactInfo.mailingAddress)
 * @returns {boolean}
 */
export const isKnownUndeliverableAddress = (
  formAddress,
  profileMailingAddress,
) =>
  profileMailingAddress?.badAddress === true &&
  isSameMailingAddress(
    formAddressToProfileShape(formAddress),
    profileMailingAddress,
  );
